import { PLATFORM_UI_DESCRIPTIONS } from "./coupons";

export const PLATFORM_ICONS = {
  web: "language",
  android: "android",
  ios: "phoneIphone",
};

export const PLATFORM_META = Object.fromEntries(
  Object.entries(PLATFORM_UI_DESCRIPTIONS).map(([key, description]) => [
    key,
    { iconName: PLATFORM_ICONS[key], description },
  ])
);
